import { render, staticRenderFns } from "./OrderComplain.vue?vue&type=template&id=c7163d74&"
import script from "./OrderComplain.vue?vue&type=script&lang=ts&"
export * from "./OrderComplain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports